module.exports = {"371428001":"广运街道","371428100":"武城镇","371428101":"老城镇","371428103":"鲁权屯镇","371428104":"郝王庄镇","371428106":"甲马营镇","371428107":"四女寺镇","371428108":"李家户镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371428.json
// module id = 1361
// module chunks = 0